import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AccessService } from '../../service/access.service';

declare const gapi: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit {

	@ViewChild('googleSignin') googleSignin: ElementRef;
	public auth2: any;
	public view: string = 'sign-in'; // sign-in, sign-up, spinner
	public errors: any = {};
	public email: string = '';
	public password: string = '';
	public confirm: string = '';

	constructor(
		private router: Router,
		public access: AccessService
	) {}

	ngOnInit() {
		if (this.access.user_data != null) {
			this.router.navigate(['/dashboard']);
		}
	}

	ngAfterViewInit() {
		this.google_init(this.googleSignin.nativeElement, (user) => {
			this.access.google_signin(user).then(() => {
				this.navigate_after_login();
			}, (err) => {
				console.error(err);
				this.view = 'sign-in';
			});
		});
	}

	login_submit(email, password, confirm = '') {
		this.errors = {};
		this.view = 'spinner';
		this.access.login_provider(email, password, confirm).then(() => {
			this.navigate_after_login();
		}, (err) => {
			switch (err.error) {
				case 'invalid_client':
				case 'passwords_differ':
					this.view = 'sign-up';
				break;

				case 'invalid_grant':
					this.errors.password = err.error_description || 'Password invalid.';
					this.view = 'sign-in';
				break;

				default:
					console.error(err.error, err.error_description);
					this.view = 'sign-in';
				break;
			}
		});
	}

	navigate_after_login() {
		const dest = this.access.redirect_url || '/dashboard';
		this.access.redirect_url = '/dashboard';
		this.router.navigate([dest]);
	}

	google_init(container, login_callback) {
		gapi.load('auth2', () => {
			this.auth2 = gapi.auth2.init({
				client_id: '1089421159529-77mvtj979ng6id617sojfp9uj0iqh8ju.apps.googleusercontent.com',
				cookiepolicy: 'single_host_origin',
				scope: 'profile email',
			});
			this.auth2.attachClickHandler(container, {
				prompt: 'select_account'
			}, (data) => {
				login_callback(data);
			}, console.error);
		});
	}
}
